export const nodeType = "INSTRUMENT_LOOP";
